<template>
  <b-card no-body class="col-12 m-0">
    <b-card-header
      v-if="section.DisplayName && section.DisplayName.length > 0"
      header-tag="h4"
      @click="toggleEditorSectionOpen({ section })"
      :class="{ 'field-changed': changed, 'field-invalid': !valid }"
      class="py-1"
    >
      <b-icon :icon="section.Icon" variant="info" aria-hidden="true"></b-icon>
      {{section.DisplayName}}
      <!-- TODO: if read-only - add an edit button! -->
      <!-- readOnly -->
      <!-- TODO: and has write permission! -->
      <b-button-toolbar v-if="readOnly && section.EffectivePermission.CanUpdate" class="float-md-right">
        <editor-section-modal
          :section="section" :obj="obj" :originalObj="originalObj"
          :editor="editor"
          @changed="changed => onChanged(changed)"
          @validated="valid => onValidated(valid)"
          fieldCols="4"
          @sectionMounted="sectionMounted"
          :addChildObject="addChildObject"
          :addChildObjects="addChildObjects"
          :removeChildObject="removeChildObject"
          :readdChildObject="readdChildObject"
          @save="(obj, section) => save(obj, section)"
          :cancel="cancel"
        />
      </b-button-toolbar>
    </b-card-header>
    <b-collapse :visible="section.open">
      <!-- TODO: this may not flow quite right -->
      <b-card-body edit-edit class="px-0" v-show="columns.length > 0">
        <!-- TODO: put this i na LOOP - and put it in an Editor Panel that's re-usable! -->
        <!-- note: not used in Model Editor (yet) -->
        <editor-field-list :fields="columns"
          :obj="obj" :originalObj="originalObj"
          :parentObj="parentObj"
          @changed="(changed, i) => onFieldChanged(i, changed)"
          @validated="(valid, i) => onFieldValidated(i, valid)"
          :fieldCols="fieldCols"
          :section="section"
          @hook:mounted="sectionMounted"
          :addChildObject="addChildObject"
          :addChildObjects="addChildObjects"
          :removeChildObject="removeChildObject"
          :readdChildObject="readdChildObject"
          @save="(obj, section) => save(obj, section)"
          :readOnly="readOnly"
          :showAddButton="showAddButton"
        />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script lang="ts">
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator'
import EditorFieldList from './editor-field-list.vue'

import EditorSectionModal from './editor-section-modal.vue'

import MxEditorComponent from '@/mixins/editor-component'
import { EditorSection } from '@/store/entity/types'
import { EditBase } from '@/store/editor/types'

@Component({
  components: {
    'editor-field-list': EditorFieldList, // () => import('./editor-field-list.vue'), // lamda because vue gets confused when nesting a control in itself
    'editor-section-modal': EditorSectionModal,
  },
})
export default class extends Mixins(MxEditorComponent) {
  public changed = false
  public valid = true

  // simple array, since we don't add/remove fields on the fly, index doesn't change
  public changedFields: boolean[] = []
  public validatedFields: boolean[] = []
  public currentTab = 0

  @Prop()
  public section!: EditorSection // the field we're editing

  @Prop()
  public fieldCols!: number

  @Prop()
  public hideBlank!: boolean

  @Prop()
  public cancel!: any

  @Prop({ default: true })
  public showAddButton!: boolean

  public mounted() {
    Vue.set(this, 'changedFields', new Array(this.section.Fields.length).fill(false))
    Vue.set(this, 'validatedFields', new Array(this.section.Fields.length).fill(true))
  }

  public save(obj: EditBase, section: EditorSection) {
    this.$emit('save', obj, section, 'editor-section')
    this.changed = false
  }

  // public cancel() {
  //   this.changed = false
  // }

  public removeItem(obj: EditBase) {
    this.$emit('removeItem', obj)
  }

  public onChanged(changed: boolean) {
    // TODO: but when it's changed, we don't want to do this anymore!
    // - we save on the close of the Modal!
    // - if anything, this can trigger
    this.changed = changed
    // this.onChanged(this.changed)
  }

  public onValidated(valid: boolean) {
    // TODO: but when it's changed, we don't want to do this anymore!
    // - we save on the close of the Modal!
    this.valid = valid
    // this.onValidated(this.valid)
  }

  public onFieldChanged(i: number, changed: boolean) {
    this.changedFields[i] = changed
    this.changed = this.changedFields.some(v => v)
    this.$emit('changed', this.changed)
  }

  public onFieldValidated(i: number, valid: boolean) {
    this.validatedFields[i] = valid
    this.valid = !this.validatedFields.some(v => !v)
    this.$emit('validated', this.valid)
  }

  public sectionMounted() {
    this.$emit('sectionMounted')
  }

  get columns() {
    return this.section.Fields // .filter(c => !c.IsId) // && c.EditorType !== 'sub-item'
  }
}
</script>
<style scoped>
</style>
